export const coreRoutes = {
  root: '/',
  notFound: '/404',
  emailConfirmation: '/confirm-email',
  resetPassword: '/reset-password',
  error: '/error',
};
